import { createDataWidget } from "@/widgets/common/createDataWidget";
import { mockFetch } from "@/widgets/common/mockFetch";
import { generatePrintVolumes } from "./mock";
import type { PrintVolumeGroupKey, PrintVolumePoint } from "./types";

/**
 * Widget state via the shared factory (D11): thunk + slice + selectors in one
 * declaration — replaces the hand-written `thunks.ts`/`slice.ts`/`selectors.ts`
 * trio. The fetch takes the granularity as its param (OEE group switcher
 * parity) — each group is an independent fetch with its own
 * pending/fulfilled lifecycle. Swapping in CubeJS replaces `mockFetch` with a
 * real fetcher.
 */
export const printVolumeChart = createDataWidget<
  PrintVolumePoint,
  PrintVolumeGroupKey | undefined
>({
  name: "printVolumeChart",
  fetcher: mockFetch((group) => generatePrintVolumes(group ?? "month")),
});
